import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const DATABASE_PROCESS_LIST_HELP: HelpContent[] = [
    {
        helpContentId: 'database-process-list.kill-process',
        tooltipText: 'Kill the process.'
    }
];
